import { myths } from '@/mocks/articles';

export default function MythSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1 rounded-full mb-4">
            误区拆解
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            毒蘑菇鉴别常见误区
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            这些广为流传的"鉴别方法"都是错的，甚至可能致命。了解真相，远离误区。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {myths.map((myth, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/70"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                  <i className={`${myth.icon} text-lg text-accent-600`}></i>
                </div>
                <div>
                  <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                    ❌ {myth.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    ✅ {myth.truth}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}